import axios from "axios";
import authHeader from "./auth-header";
import IProfile from "../types/profile.type";
import IAddress from "../types/address.type";
import IBankAccount from "../types/bank-account.type";
import IRelative from "../types/relative.type";
import IEmploymentData from "../types/employment-data.type";
import {ProfileFileNames} from "../types/enumeration/ProfileFileNames";

const API_URL = `${process.env.REACT_APP_SERVER_URL}/profile`;

export const getById = (id: string) => {
  return axios.get(API_URL + "/" + id, { headers: authHeader() });
};

export const create = (profile: IProfile) => {
  return axios.post(API_URL, profile, { headers: authHeader() });
};

export const update = (id: number, profile: IProfile) => {
  return axios.put(API_URL + "/" + id, profile, { headers: authHeader() });
};

export const updateAddress = (id: number, address: IAddress) => {
  return axios.put(API_URL + "/" + id + "/address", address, { headers: authHeader() });
};

export const updateBankAccount = (id: number, bankAccount: IBankAccount) => {
  return axios.put(API_URL + "/" + id + "/bank-account", bankAccount, { headers: authHeader() });
};

export const updateRelatives = (id: number, relatives: Array<IRelative>) => {
  return axios.put(API_URL + "/" + id + "/relatives", relatives, { headers: authHeader() });
};

export const uploadProfileFile = (id: number, file: File, profileFileName: ProfileFileNames) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';

  const formData = new FormData();

  if (file) {
    formData.append("uploadFile", file);
  }

  return axios.put(API_URL + "/" + id + "/profile-file/" + profileFileName, formData, { headers: headers });
};



export const updateEmploymentData = (id: number, employmentData: IEmploymentData) => {
  const headers = authHeader();
  headers['Content-Type'] = 'multipart/form-data';

  const formData = new FormData();

  if (employmentData.initiation) {
    formData.append("initiation", employmentData.initiation.toISOString()); // Convierte la fecha a un string ISO 8601
  }

  if (employmentData.termination) {
    formData.append("termination", employmentData.termination.toISOString());
  }

  if (employmentData.uploadInitiationFile) {
    formData.append("uploadInitiationFile", employmentData.uploadInitiationFile);
  }

  if (employmentData.uploadTerminationFile) {
    formData.append("uploadTerminationFile", employmentData.uploadTerminationFile);
  }

  return axios.put(API_URL + "/" + id + "/employment-data", formData, { headers: headers });
};
